import { render } from "./EcoPaymentView.vue?vue&type=template&id=08a766c8&scoped=true"
import script from "./EcoPaymentView.vue?vue&type=script&lang=js"
export * from "./EcoPaymentView.vue?vue&type=script&lang=js"

import "./EcoPaymentView.vue?vue&type=style&index=0&id=08a766c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a766c8"]])

export default __exports__